<template>
  <div class="container">
    <div class="row border rounded mt-1">
      <div class="col">{{ selectedAccount }}</div>
      <div class="col">
        <span class="text-danger float-end">{{
          formatIndianNotation(totalExpense)
        }}</span>
      </div>
      <div class="col">
        <span class="text-success float-end">{{
          formatIndianNotation(totalIncome)
        }}</span>
      </div>
      <div class="col">
        <span class="float-end" :class="profitorloss">{{
          formatIndianNotation(totalIncome - totalExpense)
        }}</span>
      </div>
    </div>
    <div
      class="row border rounded smalltxt"
      v-for="j in sorted_journal"
      :key="j.journal_id"
    >
      <div class="container" v-if="j.type == 'note'">
        <div class="row fst-italic fw-bold d-flex align-items-center mt-1 mb-1">
          <div class="col bg-light">
            {{ dateFormat(j.d) }}
            <i
              class="bi bi-bell-fill float-end"
              v-if="j.r"
              :class="isDue(j.r)"
            ></i>
          </div>
          <div class="col bg-light" @click="edit_note(j.journal_id)">
            {{ j.n }}
          </div>
          <div class="col bg-light">
            <button
              class="btn btn-sm btn-danger rbtn smalltxt float-end"
              v-if="isDue(j.r)"
              @click="clearReminder(j)"
            >
              Clear
            </button>
          </div>
        </div>
        <div class="row" v-if="edit_note_id == j.journal_id">
          <div class="col">
            <EditNote
              :note="j"
              @note-edited="edit_note(j.journal_id)"
            ></EditNote>
          </div>
        </div>
        <div class="row" v-if="reminder_to_clear == j.journal_id && isDue(j.r)">
          <div class="col d-flex justify-content-center">
            <ClearReminder
              :note="j"
              @reminder-cleared="clearReminder(j)"
            ></ClearReminder>
          </div>
        </div>
      </div>
      <div class="container" v-else>
        <div class="row">
          <div class="col">{{ dateFormat(j.d) }}</div>
          <!-- <div class="col">{{ j.journal_id }}</div> -->
          <div class="col" @click="selectToDelete(j.journal_id)">
            {{ getAccountName(j.account_id) }}
          </div>
          <div class="col text-muted">{{ j.n }}</div>
          <div class="col text-end" :class="getTxnType(j.t)">
            {{ formatIndianNotation(j.a) }}
          </div>

          <div class="row mt-2 mb-2" v-if="toDelete == j.journal_id">
            <div class="col d-flex align-items-center justify-content-center">
              <button
                class="btn btn-sm btn-success position-relative"
                @click="setAction('edit')"
              >
                Edit
                <span
                  class="position-absolute top-0 start-100 translate-middle p-2"
                  v-if="action == 'edit'"
                >
                  <i class="bi bi-x-lg text-danger"></i>
                </span>
              </button>
            </div>
            <div class="col d-flex align-items-center justify-content-center">
              <button class="btn btn-sm btn-danger">
                <i
                  class="bi bi-trash"
                  @click="deleteEntry(j.journal_id, j.account_id)"
                ></i>
              </button>
            </div>
          </div>
          <div class="row" v-if="action == 'edit' && toDelete == j.journal_id">
            <EditEntry :entry="j" @edit-done="edit_done()"></EditEntry>
          </div>
        </div>
      </div>
      <!-- <div class="container "></div> -->
    </div>
  </div>
</template>
<script setup>
import { useStore } from "../../store/index";
import { ref, watchEffect, computed, onMounted, onBeforeUnmount } from "vue";
import EditEntry from "../account/EditEntry.vue";
import ClearReminder from "../note/ClearReminder.vue";
import EditNote from "../note/EditNote.vue";
import { db, auth } from "../../firebase/config";
import {
  doc,
  updateDoc,
  deleteField,
  query,
  collection,
  getDocs,
  where,
  onSnapshot,
} from "firebase/firestore";
const dayjs = require("dayjs");
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
const store = useStore();
const sortby = ref("desc");
const toDelete = ref("");
const areyousure = ref(false);
const notes = ref([]);
const action = ref("");
var unsub = () => {};
const reminder_to_clear = ref("");
const edit_note_id = ref("");
const edit_note = (id) => {
  if (edit_note_id.value != id) {
    edit_note_id.value = id;
  } else {
    edit_note_id.value = "";
  }
};
const clearReminder = (j) => {
  if (reminder_to_clear.value != j.journal_id) {
    reminder_to_clear.value = j.journal_id;
  } else {
    reminder_to_clear.value = "";
  }
};
onBeforeUnmount(() => {
  //console.log("unsubbing notes... ");
  unsub();
});
onMounted(async () => {
  const q = query(
    collection(db, "notes"),
    where("org", "==", store.active_org)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((docy) => {
    // doc.data() is never undefined for query doc snapshots
    unsub = onSnapshot(doc(db, "notes", docy.id), (docd) => {
      const ns = [];
      for (const property in docd.data().journal) {
        ns.push({
          account_id: docy.id,
          journal_id: property,
          ...docd.data().journal[property],
          type: "note",
        });
      }
      notes.value = ns;
    });
  });
});
const edit_done = () => {
  setAction("");
  toDelete.value = "";
};
const isDue = (d) => {
  return dayjs().isAfter(dayjs(d), "day") ? "text-danger" : "";
};
const setAction = (a) => {
  if (action.value != a) {
    action.value = a;
  } else {
    action.value = "";
  }
};
const selectToDelete = (jid) => {
  if (toDelete.value != jid) {
    toDelete.value = jid;
  } else {
    toDelete.value = "";
  }
};
const journal = ref([]);
watchEffect(() => {
  journal.value = [];
  for (const n of notes.value) {
    journal.value.push({ ...n });
  }
  store.accounts.forEach((account) => {
    //when no account is selected for entry
    if (account.active) {
      for (const property in account.journal) {
        journal.value.push({
          account_id: account.id,
          journal_id: property,
          ...account.journal[property],
          //...account.journal[property].ts, //this is done to make sorting easier
        });
      }
    }
  });
});
const sorted_journal = computed(() => {
  var arr = [];
  journal.value.forEach((j) => {
    if (j.d) {
      if (!store.active_account && withinDates(j.d)) {
        arr.push(j);
      } else {
        if (j.account_id == store.active_account && withinDates(j.d)) {
          arr.push(j);
        }
      }
    }
  });
  var sorted_arr = sortByField(arr, "d");
  return sorted_arr;
});
// const withinDates = (timestamp) => {
//   const startDate = dayjs(store.start_date);
//   const endDate = dayjs(store.end_date).endOf("day"); // Include the entire last day

//   // Convert the timestamp to milliseconds since Day.js works with milliseconds
//   const dateToCheck = dayjs.unix(timestamp);

//   // Check if the timestamp falls within the range
//   const isWithinRange = dateToCheck.isBetween(startDate, endDate, null, "[]");
//   return isWithinRange;
// };
function withinDates(value) {
  value = value.split(" ");
  value = value[0];
  const startDate = dayjs(store.start_date);
  const endDate = dayjs(store.end_date);
  const dateToCheck = dayjs(value);
  return dateToCheck.isAfter(startDate) && dateToCheck.isBefore(endDate);
}
function sortByField(arr, field) {
  if (sortby.value == "asc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] > b[field]) {
        return 1;
      } else if (a[field] < b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  if (sortby.value == "desc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] < b[field]) {
        return 1;
      } else if (a[field] > b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
}
const getTxnType = (txn) => {
  var cl = "";
  if (txn == "i") {
    cl = "text-success";
  }
  if (txn == "e") {
    cl = "text-danger";
  }
  return cl;
};
function formatIndianNotation(number) {
  // Convert the number to a string
  const numStr = number.toString();

  // Split the string into whole number and decimal parts
  const [whole, decimal] = numStr.split(".");

  // Match and format the whole number part
  // const formattedWhole = whole
  //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  //   .replace(/(\d+)(?=(\d{2})+\d$)/g, "$1,");

  const formattedWhole = whole
    .replace(/\B(?=(\d{2})+(\d{3})+(?!\d))/g, ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Combine the formatted whole number with the decimal part, if present
  return decimal ? `${formattedWhole}.${decimal}` : formattedWhole;
}
const dateFormat = (t) => {
  // const timestamp = t * 1000;

  // // Format the date using Day.js
  // const formattedDate = dayjs(timestamp).format("DD-MMM-YY");
  // return formattedDate;
  return dayjs(t.split(" ")[0]).format("DD-MMM-YY");
};
const getAccountName = (id) => {
  var name = "";
  store.accounts.forEach((a) => {
    if (a.id == id) {
      name = a.name;
    }
  });
  return name;
};
const totalIncome = computed(() => {
  var income = 0;
  sorted_journal.value.forEach((j) => {
    if (j.t == "i") {
      income = income + j.a;
    }
  });
  return income;
});
const totalExpense = computed(() => {
  var expense = 0;
  sorted_journal.value.forEach((j) => {
    if (j.t == "e") {
      expense = expense + j.a;
    }
  });
  return expense;
});
const profitorloss = computed(() => {
  var profit = "";
  if (totalIncome.value >= totalExpense.value) {
    profit = "text-success";
  } else {
    profit = "text-danger";
  }
  return profit;
});
const selectedAccount = computed(() => {
  var name = "";
  if (store.active_account) {
    store.accounts.forEach((a) => {
      if (a.id == store.active_account) {
        name = a.name;
      }
    });
  }
  return name;
});
const deleteEntry = async (jid, aid) => {
  console.log(jid, aid);
  const accountRef = doc(db, "accounts", aid);

  // Remove the 'capital' field from the document
  await updateDoc(accountRef, {
    ["journal." + jid]: deleteField(),
  });
};
</script>
<style scoped>
.smalltxt {
  font-size: 12px;
}
.rbtn {
  padding: 2px;
}
</style>
